export const GET_PANELS_STREETLIGHTS_INFO_ACTION = "getPanelsStreetlightsInfoAction";
export const PANELS_STREETLIGHTS_INFO_LOADING_ACTION = "panelsStreetlightsInfoLoadingAction";
export const PANELS_STREETLIGHTS_INFO_SUCCESS_ACTION = "panelsStreetlightsInfoSuccessAction";
export const PANELS_STREETLIGHTS_INFO_FAILURE_ACTION = "panelsStreetlightsInfoFailureAction";

// GET PANELS STREETLIGHTS ACTION
export const getPanelsStreetlightsInfoAction = (payload) => ({
    type: GET_PANELS_STREETLIGHTS_INFO_ACTION,
    payload
  });
  
  export const panelsStreetlightsInfoLoadingAction = () => ({
    type: PANELS_STREETLIGHTS_INFO_LOADING_ACTION,
  });
  
  export const panelsStreetlightsInfoSuccessAction = (payload) => ({
    type: PANELS_STREETLIGHTS_INFO_SUCCESS_ACTION,
    payload,
  });
  
  export const panelsStreetlightsInfoFailureAction = (payload) => ({
    type: PANELS_STREETLIGHTS_INFO_FAILURE_ACTION,
    payload,
  });
